'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _printedPlacementsMdl = require('./printed-placements.mdl.scss');

var _printedPlacementsMdl2 = _interopRequireDefault(_printedPlacementsMdl);

var _events = require('../../../../../events');

var _events2 = _interopRequireDefault(_events);

var _print = require('../../../../../print');

var _print2 = _interopRequireDefault(_print);

var _ifeisIsomorphic = require('ifeis-isomorphic');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PrintedPlacementsController = function () {
  function PrintedPlacementsController($scope, $timeout, feis, fFeisService, fEventService, fPrint, msgService, $sce, fAlert) {
    _classCallCheck(this, PrintedPlacementsController);

    this._ = { $scope: $scope, $timeout: $timeout, fFeisService: fFeisService, fEventService: fEventService, fPrint: fPrint, msgService: msgService, $sce: $sce, fAlert: fAlert };
    this._events = fEventService.for(feis.id);
    this.loading = 0;
    this.feis = feis;

    this.updateResults();
  }

  _createClass(PrintedPlacementsController, [{
    key: 'updateResults',
    value: function updateResults() {
      var _this = this;

      return this._.fFeisService.resultsQueue(this.feis.id).then(function (e) {
        return _this.results = e;
      }, function (err) {
        return _this._.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: 'generatePlacementSheet',
    value: function generatePlacementSheet(event) {
      var _this2 = this;

      // FIXME: add progress indicator
      return this._.fPrint.getLogo().then(function (logo) {
        return _this2.logo = logo;
      }).then(function () {
        return _this2._events.placements(event.id);
      }).then(function (placements) {
        var _$fPrint$metrics = _this2._.fPrint.metrics(),
            margin = _$fPrint$metrics.margin,
            pageWidth = _$fPrint$metrics.pageWidth,
            useablePageWidth = _$fPrint$metrics.useablePageWidth,
            pageHeight = _$fPrint$metrics.pageHeight;

        var doc = _this2._.fPrint.create('placement-sheet.pdf');
        var headlineSize = 48;
        var eventTitleSize = 36;
        var subheadSize = 25;
        var textSize = 14;
        var footerSize = 8;
        var positionY = margin;

        doc.image(_this2.logo, 10, 10, { width: 60 });

        _this2._addFooter(doc, _this2.feis.name, _this2._.fPrint.metrics(), footerSize);

        doc.fontSize(headlineSize);
        doc.text(event.name, margin, positionY, {
          align: 'center',
          width: useablePageWidth,
          lineGap: 1,
          lineBreak: false
        });
        positionY += headlineSize;

        doc.fontSize(eventTitleSize);
        doc.text((0, _ifeisIsomorphic.getTitle)(event), margin, positionY, {
          align: 'center',
          width: useablePageWidth,
          lineGap: 1,
          lineBreak: false
        });
        positionY += 3 * eventTitleSize;

        placements.filter(function (c) {
          return c.score.placed === 1;
        }).sort(function (a, b) {
          return a.score.placement - b.score.placement;
        }).forEach(function (placement, idx) {

          if (idx === 10) {
            doc.addPage();
            positionY = margin;
          }
          var positionX = margin;

          doc.fontSize(headlineSize);
          doc.text(placement.score.placement, positionX, positionY, {
            align: 'left',
            width: useablePageWidth * 0.15,
            height: headlineSize,
            lineBreak: false,
            ellipsis: true
          });
          positionX += useablePageWidth * 0.2;

          doc.text(placement.competitor, positionX, positionY, {
            align: 'left',
            width: useablePageWidth * 0.25,
            height: headlineSize,
            lineBreak: false,
            ellipsis: true
          });
          positionX += useablePageWidth * 0.2;

          doc.fontSize(subheadSize);
          doc.text(placement.fname + ' ' + placement.lname, positionX, positionY, {
            align: 'left',
            width: useablePageWidth * 0.6,
            height: subheadSize,
            lineBreak: false,
            ellipsis: true
          });

          doc.fontSize(textSize);
          doc.text(placement.school.name, positionX, positionY + subheadSize, {
            align: 'left',
            width: useablePageWidth * 0.6,
            height: textSize,
            lineBreak: false,
            ellipsis: true
          });

          positionY += headlineSize;
        });

        return _this2._.fPrint.download(doc);
      }).catch(function (e) {
        return _this2._.msgService.displayErrorMsg(e);
      });
    }
  }, {
    key: 'generateRecallSheet',
    value: function generateRecallSheet(event) {
      var _this3 = this;

      // FIXME: add progress indicator
      return this._.fPrint.getLogo().then(function (logo) {
        return _this3.logo = logo;
      }).then(function () {
        return _this3._events.participants(event.id);
      }).then(function (placements) {
        var doc = _this3._.fPrint.create('recall-sheet.pdf');
        var headlineSize = 64;
        var subheadSize = 24;
        var footerSize = 8;

        _this3._addFooter(doc, _this3.feis.name, _this3._.fPrint.metrics(), footerSize);

        doc.fontSize(subheadSize);
        doc.text((0, _ifeisIsomorphic.getDescription)(event), {
          align: 'center',
          lineBreak: true
        });
        doc.moveDown();
        doc.text('Recall', {
          align: 'center',
          lineBreak: true
        });

        doc.moveDown();
        doc.moveDown();

        doc.text(placements.length >= 1 ? 'Competitors:' : 'No competitors...', {
          align: 'center',
          lineBreak: true
        });
        doc.moveDown();

        if (placements.length >= 1) {
          doc.fontSize(headlineSize);

          placements.filter(function (r) {
            return r.reg.placed === 1;
          }).sort(function (a, b) {
            return a.competitor - b.competitor;
          }).forEach(function (placement, idx) {
            doc.text(placement.competitor, {
              align: 'center',
              lineBreak: true
            });
          });
        }

        return _this3._.fPrint.download(doc);
      }).catch(function (e) {
        return function (e) {
          return _this3._.msgService.displayErrorMsg(e);
        };
      });
    }
  }, {
    key: '_addFooter',
    value: function _addFooter(doc, footerText, pageMetrics, fontSize) {
      var oldX = doc.x;
      var oldY = doc.y;

      var margin = pageMetrics.margin,
          pageWidth = pageMetrics.pageWidth,
          pageHeight = pageMetrics.pageHeight;

      doc.fontSize(fontSize);
      doc.text(footerText, pageWidth / 2.5, pageHeight - margin * 1.5);

      // reset position so that the next lines are appropriately placed
      doc.x = oldX;
      doc.y = oldY;
    }
  }, {
    key: 'togglePlacementsPrinted',
    value: function togglePlacementsPrinted(event, newVal, $event) {
      var _this4 = this;

      this._events.setPlacementsPrinted(event.id, newVal, event.version_id).then(function (res) {
        _this4.updateResults(); // TODO API needed to mark an event as UNprinted
      }, function (err) {
        if (err && err.data && err.data.errors && err.data.errors[0].code === 417) {
          var _err$data$errors$ = err.data.errors[0],
              title = _err$data$errors$.title,
              detail = _err$data$errors$.detail;

          _this4._.fAlert($event, title, detail);
        } else {
          _this4._.msgService.displayErrorMsg(err);
        }
      });
    }
  }, {
    key: 'toggleRecallsPrinted',
    value: function toggleRecallsPrinted(event, newVal, $event) {
      var _this5 = this;

      this._events.setRecallsPrinted(event.id, newVal, event.version_id).then(function (res) {
        _this5.updateResults(); // TODO API needed to mark an event as UNprinted
      }, function (err) {
        if (err && err.data && err.data.errors && err.data.errors[0].code === 417) {
          var _err$data$errors$2 = err.data.errors[0],
              title = _err$data$errors$2.title,
              detail = _err$data$errors$2.detail;

          _this5._.fAlert($event, title, detail);
        } else {
          _this5._.msgService.displayErrorMsg(err);
        }
      });
    }
  }, {
    key: 'getEventName',
    value: function getEventName(event) {
      if (event) {
        return (0, _ifeisIsomorphic.getDescription)(event);
      }
    }
  }]);

  return PrintedPlacementsController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.printed-placements', ['ifeis.events', 'ifeis.printing', 'ifeis.router-history']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.printed-placements', {
    url: '/printed-placements',
    template: require('./printed-placements.mdl.html'),
    controller: PrintedPlacementsController,
    controllerAs: 'pp',
    ncyBreadcrumb: {
      label: 'Printed Placements',
      parent: 'feiseanna.one.admin.manager'
    }
  });
}).filter('prntd_places', function () {
  return function (input, printed) {
    if (input) {
      var out = input.filter(function (event) {
        return event.prntd_places == printed;
      });
      return out;
    }
  };
}).filter('prntd_recall', function () {
  return function (input, printed) {
    if (input) {
      var out = input.filter(function (event) {
        return event.prntd_recall == printed;
      });
      return out;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/printed-placements/printed-placements.mdl.js
// module id = 551
// module chunks = 0